<template>
  <nav aria-label="Menu principal" class="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
    <MenuItem
      v-for="item in menuItems"
      :key="item.title"
      :item="item"
      :collapsed="collapsed"
    />
  </nav>
</template>

<script setup lang="ts">
import MenuItem from './MenuItem.vue'
import type { MenuItem as MenuItemType } from '@/composables/useMenuPermissions'

interface Props {
  menuItems: MenuItemType[]
  collapsed: boolean
}

defineProps<Props>()
</script>
